import { observer } from 'mobx-react-lite'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { Box } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { getExportReportAction } from 'widgets/ExportAnalyticsModal'
import { useSurveysContext } from 'pages/surveys/context/surveysContext'
import { getSurveyRowActions } from 'pages/surveys/ui/actions'
import { SurveysPath } from 'pages/surveys'
import { getSurveysColumns } from './columns'

export const SurveysTable = observer(() => {
  const entities = useEntitiesContext()
  const {
    tableStore,
    search,
    setSearch,
    items,
    scrollToTopTrigger,
    onDeleteItem,
    openExportModal,
  } = useSurveysContext()

  const rows = items.map((item) => {
    item.setActionsProps({
      actions: getSurveyRowActions(
        item,
        onDeleteItem,
        getExportReportAction({
          disabled: !item.totalSent,
          onExport: () => openExportModal(item.id),
        })
      ),
    })

    return item
  })

  return (
    <>
      <TableSearch value={search} onChange={setSearch} />
      <Box flexGrow={1}>
        <Table
          virtualization
          ariaLabel={'SurveysTable'}
          store={tableStore}
          columns={getSurveysColumns(entities)}
          rows={rows}
          emptyStateProps={{
            text: 'No results found',
          }}
          scrollToTOpTrigger={scrollToTopTrigger}
          onRowClick={(row) => {
            uiStore.changeRouteViaVue({
              path: `/${SurveysPath.view(row.id)}`,
            })
          }}
        />
      </Box>
    </>
  )
})
